export default __webpack_public_path__ + "static/media/playngo-mono.01ed4f0f.svg";